import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@tinct/web-components';
import { Game } from './game';

export interface GameModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const GameModal = ({ open, onOpenChange }: GameModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton
        className="sm:max-w-5xl gap-0 overflow-hidden rounded-3xl p-0"
      >
        <DialogTitle className="sr-only">Game</DialogTitle>
        <div className="p-2">
          <Game className="overflow-hidden rounded-2xl" />
        </div>
      </DialogContent>
    </Dialog>
  );
};
